import {
    LabeledComponentDefinition,
    ValueComponent,
    ValueComponentDefinition
} from "components/components/Component";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import i18n from "components/i18n/i18n";
import template from "./html.hbs";

export class Html extends ValueBaseComponent<HtmlComponentDefinition> implements ValueComponent {
    public id: string;
    public componentType: "html";

    constructor(definition: HtmlComponentDefinition) {
        super(definition);
        this.definition.width = this.definition?.width ?? 16;
    }
    public render(): Element {
        const d = document.createElement("div");
        let message;
        if (this.definition.content != null) {
            message = this.definition.content;
        } else {
            message = Html.mergeMessage(this.definition.labelKey);
        }
        const t = template(Object.assign(
            this.definition,
            { content: message }));
        this.setInnerHTML(d, t);
        this.view = d as HTMLElement;
        return this.view;
    }
    setInnerHTML = function (elm, html) {
        elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
            const os = oldScript as HTMLScriptElement
            const newScript = document.createElement("script");
            Array.from(os.attributes)
                .forEach(attr => newScript.setAttribute(attr.name, attr.value));
            if (!newScript.hasAttribute("async")) {
                newScript.async = false;
            }
            newScript.appendChild(document.createTextNode(os.innerHTML));
            os.parentNode.replaceChild(newScript, os);
        });
    }

    private static mergeMessage(def): string {
        let message;
        if (Array.isArray(def)) {
            message = def.join("\n");
        } else {
            message = i18n.instance.t(def);
            if (Array.isArray(message)) {
                message = message.join("\n");
            }
        }
        return message;
    }
    public getValue() {
        throw new Error("Method not implemented.");
    }

    public value(data: string): void {
        const message = Html.mergeMessage(data);
        this.view.innerHTML = template(Object.assign(
            this.definition,
            { content: message }));
    }

    public postRender(): Node {
        return this.view;
    }
}

export interface HtmlComponentDefinition extends ValueComponentDefinition, LabeledComponentDefinition {
    content: string;
}
